import { AddressChoiceModel } from '../../models/item_js_env';

export class DeliveryCountdown {
    static updateElement(model: AddressChoiceModel) {
        // 更新するelement
        const element = document.getElementById('js-deliverydate-countdown');
        // 更新するhelpIcon
        const helpIcon = document.getElementById('js-deliverydate-helpIcon');
        if (!element) return;

        // 基準日時 システム日時に1秒足した値を基準日時とするため、dateにしたあとに1秒足している
        const referenceDate: Date = new Date(model.systemDateTime)
        referenceDate.setSeconds(referenceDate.getSeconds() + 1)
        // 受注締め日時
        const orderClosingDateTime: Date = new Date(model.orderClosingDateTime);
        // 希望数量element
        const hopeQuantityElement = document.getElementById('hopeQuantity') as HTMLInputElement;
        // 希望数量
        const hopeQuantity = hopeQuantityElement ? hopeQuantityElement.value : '0';
        // 在庫数element
        const stockCountElement = document.getElementById('stockCount') as HTMLInputElement;
        // 在庫数
        const stockCount = stockCountElement ? stockCountElement.value : '0';
        // loadイベント時に開始
        window.addEventListener('load', function(){
            // 在庫表示エリアの文言更新
            const timer = setInterval(
                () => {
                    if (element == null) {
                        clearInterval(timer);
                        return;
                    };

                    // 基準日時に1秒足す
                    referenceDate.setSeconds(referenceDate.getSeconds() + 1)

                    // 秒数が0でない場合は分が更新されなく、以降処理する必要がないのでreturnする
                    // ただし初回は更新する必要があるのでinnerHTMLが空の場合はreturnさせない
                    if (referenceDate.getSeconds() != 0 && element.innerHTML != "") {
                        return;
                    }

                    if (referenceDate.getTime() < orderClosingDateTime.getTime()) {
                        // 基準日時が受注締め日時以前の場合のみ、残り時間文字列に差し替える
                        const timeDiff = Math.ceil((orderClosingDateTime.getTime() - referenceDate.getTime()) / (1000 * 60))
                        const hours = Math.floor(timeDiff / 60)
                        const minutes = timeDiff - (hours * 60)
                        if (hours === 0) {
                            if (Number(hopeQuantity) <= Number(stockCount)) {
                                element.innerHTML = `お届け日：今から<b>` +
                                    `${minutes.toString()}分以内</b>のご注文で、<b>` +
                                    `${model.deliveryDateWording}</b>にお届け`;
                            } else {
                                element.innerHTML =
                                `お届け日：<span>数量${stockCount.toString()}点以下に限り</span>、` +
                                `今から<b>${minutes.toString()}分以内</b>のご注文で、`+
                                `<b>${model.deliveryDateWording}</b>にお届け`;
                            }
                        } else {
                            if (Number(hopeQuantity) <= Number(stockCount)) {
                                element.innerHTML = `お届け日：今から<b>` +
                                    `${hours.toString()}時間${minutes.toString()}分以内</b>のご注文で、<b>` +
                                    `${model.deliveryDateWording}</b>にお届け`;
                            } else {
                                element.innerHTML =
                                `お届け日：<span>数量${stockCount.toString()}点以下に限り</span>、` +
                                `今から<b>${hours.toString()}時間${minutes.toString()}分以内</b>のご注文で、`+
                                `<b>${model.deliveryDateWording}</b>にお届け`;
                            }
                        }
                        // カウントダウン処理で「お届け日：～」表示パタンで、画面は最終的には「お届け日：～　？マーク」と表示されるが、
                        // カウントダウン描画処理が遅延する場合に？マークだけ先に表示される場合があり、
                        // その後に「お届け日：～　？マーク」と表示されることがあるため、以下処理を追加対応する
                        if (helpIcon != null) {
                            helpIcon.style.display = 'inline'
                         }
                    } else {
                        clearInterval(timer)
                        element.innerHTML = `<a href="javascript:location.reload();" id="js-get-new-deliverydate">最新のお届け日を表示</a>`;
                        if (helpIcon != null) {
                            helpIcon.style.display = 'none'
                         }
                    };
                },
                1000
            )
        })
    }
}
